// src/pages/myprofile/FeelLikeApp.jsx
import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import FeelLikeAppData from '../../components/FeelLikeAppData';

const FeelLikeApp = () => {
  const authState = useSelector(state => state.authReducer);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectingModule, setSelectingModule] = useState(null);
  const [updatedAppLike, setUpdatedAppLike] = useState(false);
  const [sameModuleMessage, setSameModuleMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
    // console.log("Component mounted, fetching user landing data...");
    const fetchCurrentLanding = async () => {
      try {
        const response = await fetch("/api/userlanding", {
          headers: { Authorization: authState.token }
        });
        // console.log("User landing data response...", response);
        if (!response.ok) {
          throw new Error('Failed to fetch user landing');
        }
        const data = await response.json();
        // console.log("User landing data...", data);
        setSelectedModule(data);
      } catch (error) {
        console.error("Error fetching user landing:", error);
      }
    };

    fetchCurrentLanding();
  }, [authState.isLoggedIn, authState.token]);

  const handleRadioChange = (module) => {
    setSelectingModule(module);
    // setSuccessMessage(false);
  };

  const handleSetAsApp = async () => {
    try {
      if (selectedModule.appTitle === selectingModule.title) {
        setSameModuleMessage(true);
        return;
      }

      const response = await fetch("/api/userlanding", {
        method: "PUT",
        headers: {
          Authorization: authState.token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          appTitle: selectingModule.title,
          moduleHomeRoutes: selectingModule.landingPageUrl,
          hasCustomDashboard: 0
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update app like');
      }

      const data = await response.json();
      setSuccessMessage(true);
    } catch (error) {
      console.error("Error updating app like:", error);
    }
  };

  return (
    <div className='bg-black'>
      <div className='px-4 text-lg py-2 border-b border-b-gray-300 text-white'>
          <h3 className='text-lg lg:text-2xl text-left text-yellow-200'>Make It Feel Like An App</h3>
      </div>
      <div className="dashboard justify-center" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        <div className="module-selection text-center">
          <p className='text-yellow-400 text-m lg:text-lg justify-center'>Select one of the following modules of your choice that where you will land after login!!!</p>
        </div>
      </div>
      <div className="dashboard" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        <div className="module-selection text-center">
          {selectedModule && (
            <p className='text-white text-sm lg:text-m mt-1'>Currently You Have <span className={`text-orange-600 ${selectedModule.appTitle ? 'border-yellow-400 border-2px' : ''}`}>{selectedModule.appTitle ? selectedModule.appTitle : 'No app selected'}</span> as your default module</p>
          )}
          {selectingModule && (
            <p className='text-white text-sm lg:text-lg m-1'>You are selecting <span className='text-yellow-300'>{selectingModule.title}</span> as your new default module</p>
          )}
        </div>
      </div>
      <div className="dashboard" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {FeelLikeAppData.map((module, index) => (
          <div key={index} className="module" style={{ textAlign: 'center', margin: '15px' }}>
            <div>
              <div 
                className="icon" 
                style={{ 
                  fontSize: '64px', 
                  marginBottom: '10px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  width: '130px',
                  height: '88px',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px'
                }}
              >
                {module.icon}
              </div>
            </div>
            <div className="module-title" style={{ color: 'white', fontSize: '12px' }}>
              <label htmlFor={`app-${index}`}>
                <input
                  type="radio"
                  name="app"
                  id={`app-${index}`}
                  checked={selectingModule === module}
                  onChange={() => handleRadioChange(module)}
                  className="radio-input"
                  style={{ marginBottom: '5px' }}
                />
                {module.title}
              </label>
              {selectingModule === module && (
                <>
                <div style={{ marginTop: '5px' }}>
                  {selectedModule === module ? (
                    <p className="text-red-500">Old and New One are the same. Select different one.</p>
                  ) : (
                    <button
                      onClick={() => handleSetAsApp(module)}
                      style={{ width: '50px', padding: '0 2px', backgroundColor: 'yellow', color: 'darkblue' }}
                    >
                      Set As App
                    </button>
                  )}
                </div>
                { successMessage && (
                  <div>
                    <p>"Set As Default. Re-login"</p>
                  </div>
                )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
      <footer className="bg-black border-t border-blue-400 text-white py-4 mt-2">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm lg:text-lg text-yellow-200">
            (c) 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-[#005C5C]">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-[#005C5C]">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-[#005C5C]">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-[#005C5C]">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default FeelLikeApp;